
export const COMMISSION_DIMENSION = ['percent', 'fixed'];

